<template>
  <section class="pb-[80px] xl:pb-[120px]" id="our-founders">
    <div class="container">
      <SectionTitle :title="$t('landing.team.title')" class="!items-start" />
      <div class="relative p-4 -m-4">
        <Swiper
          ref="swiper"
          clas="team-slider"
          :modules="[Navigation, Pagination]"
          :navigation="{
            nextEl: '.custom-next',
            prevEl: '.custom-prev',
          }"
          pagination
          v-bind="settings"
          :breakpoints="{
            '320': {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            '640': {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            '768': {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            '1024': {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <SwiperSlide v-for="(member, idx) of Team" :key="idx">
            <CardTeam v-bind="{ member }" />
          </SwiperSlide>
        </Swiper>
        <!-- Custom Navigation -->
        <div
          v-if="swiperInstance"
          class="absolute bottom-0 left-0 w-full flex-y-center z-20"
        >
          <button
            v-if="!isAtStart"
            class="px-3 h-[32px] rounded-lg bg-dark text-white font-semibold flex-y-center gap-1.5 custom-next mr-auto text-sm"
            @click="handlePrevSlide"
          >
            <span class="leading-[14px] hidden lg:block">Prev</span>
            <span class="icon-arrow-right rotate-180 block lg:hidden"></span>
          </button>
          <button
            v-if="!isAtEnd"
            class="px-3 h-[32px] rounded-lg bg-dark text-white font-semibold flex-y-center gap-1.5 custom-next ml-auto text-sm"
            @click="handleNextSlide"
          >
            <span class="leading-[14px] hidden lg:block">Next</span>
            <span class="icon-arrow-right block lg:hidden"></span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import CardTeam from "@/modules/Landing/components/Card/Team.vue";
import { ref } from "vue";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { Swiper, SwiperSlide } from "swiper/vue";
import { Team } from "@/data/index";

const settings = {
  grabCursor: true,
  spaceBetween: 24,
  center: true,
};

const swiperInstance = ref(null);
const isAtStart = ref(true); // Disable "Prev" at start
const isAtEnd = ref(false); // Disable "Next" at end

const onSwiper = (swiper): void => {
  swiperInstance.value = swiper;
  updateNavigationStates();
};
// Update button states on slide change
const onSlideChange = () => {
  updateNavigationStates();
};
const handlePrevSlide = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slidePrev();
    updateNavigationStates();
  }
};
const handleNextSlide = () => {
  if (swiperInstance.value) {
    swiperInstance.value.slideNext();
    updateNavigationStates();
  }
};
// Update the navigation button states
const updateNavigationStates = () => {
  if (swiperInstance.value) {
    isAtStart.value = swiperInstance.value.isBeginning;
    isAtEnd.value = swiperInstance.value.isEnd;
  }
};
</script>

<style>
.swiper-wrapper {
  align-items: end !important;
}
</style>
